<template>
  <main data-theme="default">
    <a
      class="skip-link"
      href="#main-content-section"
      tabindex="1"
    >Skip To Main Content</a>
    <Header />
    <section
      id="main-content-section"
      class="main-content"
    >
      <slot />
    </section>
    <Footer />
  </main>
</template>
